<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Cuenta</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item active">Cuenta</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <button class="btn btn-theme" @click="cerrar">Cerrar</button>
        <br>
        <br>
        <div class="form-group">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Nombre</strong> </label>
                <p v-text="account.name"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Descripción</strong> </label>
                <p v-text="account.description"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Cantidad</strong> </label>
                <p v-text="formatQuetzales(account.amount)"/>
                <!-- <p v-text="formatQuetzales(account.amount)"/> -->
              </div>
            </div>
            <div v-if="account.bank==null" class="col-md-3">
              <div class="form-group">
                <label><strong>Banco</strong> </label>
                <p>Sin banco</p>
              </div>
            </div>
            <div v-else class="col-md-3">
              <div class="form-group">
                <label><strong>Banco</strong> </label>
                <p v-text="account.bank.name"/>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Localidades</strong> </label>
                <!-- <p v-text="account.places"/> -->
                <p v-text="mostrarArray(account.places)"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Tipos de pago que recibe</strong> </label>
                <!-- <p v-text="account.payments"/> -->
                <p v-text="mostrarArray(account.payments)"/>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Estado</strong> </label>
                <br>
                <span v-if="account.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <strong><span>Transacciones de la cuenta</span></strong>
        <table class="table table-responsive">
          <thead>
            <tr>
              <th>No.</th>
              <!-- <th>id</th> -->
              <th>Descripción</th>
              <th>Documento de banco</th>
              <th>Foto del comprobante</th>
              <th>Cantidad</th>
              <th>Cuenta</th>
              <th>Empleado</th>
              <th>tipo de transacción</th>
              <th>Forma de transacción</th>
              <th>Estado</th>
              <th>Fecha de registro</th>
              <!-- <th>Opciones</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="transaction in transactionsArray" :key="transaction.id">
              <td v-text="'Transacción' + ' ' + transaction.document_number"/>
              <!-- <td v-text="transaction.id"/> -->
              <td v-text="transaction.description"/>
              <td v-if="transaction.document_number_bank==null">Sin documento de banco</td>
              <td v-else v-text="transaction.document_number_bank"/>
              <td>
                <p v-if="transaction.photo=='transaction.png'">No tiene comprobante</p>
                <button v-tooltip.top-center="'Ver foto de comprobante'" v-else class="btn btn-info btn-block" @click="openModal(transaction.photo)"><i class="icon-fa icon-fa-eye"/></button>
                <!-- <img :src="'/transactions/'+transaction.photo" class="imgRedondo" > -->
              </td>
              <!-- <td v-text="transaction.amount"/> -->
              <td v-text="formatQuetzales(transaction.amount)"/>
              <td v-text="transaction.account.name"/>
              <td v-text="transaction.employee.person.name"/>
              <td>
                <span v-if="transaction.type_transaction==1" class="btn btn-primary btn-sm">Depósito</span>
                <span v-else class="btn btn-warning btn-sm">Retiro</span>
              </td>
              <td v-if="transaction.payments" v-text="transaction.payments.name"/>
              <td v-else>Depósito inicial</td>
              <td>
                <span v-if="transaction.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Anulado</span>
              </td>
              <td v-text="transaction.created_at"/>
              <!-- <td>
                <template>
                  <div class="table__actions">
                    <button v-if="transaction.state==1" class="btn btn-danger" @click="openModal('cancel', transaction)"><i class="icon-fa icon-fa-ban"/>Anular</button>
                    <a/>
                  </div>
                </template>
              </td> -->
            </tr>
          </tbody>
        </table>

        <!--Paginación de tabla-->
        <div class="card">
          <div class="card-body">
            <ul class="pagination pagination-primary m-b-0">
              <li v-if="pagination.current_page > 1" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search)"><i class="icon-fa icon-fa-angle-left"/></a>
              </li>
              <li v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(page, search)" v-text="page"/>
              </li>
              <li v-if="pagination.current_page < pagination.last_page" class="page-item">
                <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search)"><i class="icon-fa icon-fa-angle-right"/></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <sweet-modal
        ref="photoModal"
        modal-theme="dark"
        overlay-theme="dark"
      >
        <br><br>
        <img :src="photoTrans" class="imgRedondo" >
      </sweet-modal>
    </div>
  </div>
</template>
<script>
import { SweetModal } from 'sweet-modal-vue'
export default {
  components: {
    SweetModal
  },
  // props: {
  //   account: {
  //     type: Object
  //   }
  // },
  data () {
    return {
      transactionsArray: [],
      account: {},
      pagination: {
        'total': 0,
        'current_page': 0,
        'per_page': 0,
        'last_page': 0,
        'from': 0,
        'to': 0
      },
      offset: 3,
      search: '',
      photoTrans: ''
    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return []
      }
      var from = this.pagination.current_page - this.offset
      if (from < 1) {
        from = 1
      }
      var to = from + (this.offset * 2)
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page
      }
      var pagesArray = []
      while (from <= to) {
        pagesArray.push(from)
        from++
      }
      return pagesArray
    }
  },
  mounted () {
    this.getAccount(this.$route.query.item)
    this.fetchData(1, this.$route.query.item)
  },
  methods: {
    getAccount (id) {
      let me = this
      axios.get(`/api/admin/account/getAccount?id=${id}`)
        .then(function (response) {
          me.account = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    changePage (page) {
      let me = this
      // Actualiza la página actual
      me.pagination.current_page = page
      // Envia la petición para visualizar la data de esa página
      me.fetchData(page, me.account.id)
    },
    async fetchData (page, item) {
      let me = this
      const response = await axios.get(
        `/api/admin/detailTransaction/searchTransactions?page=${page}&item=${item}`
      )
        .then(function (response) {
          var respuesta = response.data
          me.transactionsArray = respuesta.transactions.data
          me.pagination = respuesta.pagination
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    mostrarArray (item) {
      if (item == undefined) {
        // console.log('se chingo')
      } else {
        var letra = ''
        item.forEach(element => {
          letra = letra + ', ' + element.name
          // letra += element.name + ''
        })
        letra = letra.substring(2, letra.length)
        return letra
      }
    },
    formatQuetzales (amount) {
      var num = parseFloat(amount), formatted
      formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      return amount = 'Q ' + formatted
    },
    accountnull () {
      if (this.account == undefined) {
        // console.log(true)
        this.$router.push({name: 'Cuentas'
        })
      } else {
        this.fetchData(1, this.account.id)
      }
    },
    openModal (photo) {
      this.$refs.photoModal.open()
      this.photoTrans = '/transactions/' + photo
    },
    cerrar () {
      if (this.account.isPettyCash == true) {
        this.$router.push({
          name: 'cash'
        })
      } else {
        this.$router.push({
          name: 'Cuentas'
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/admin/account/Transactions.vue